var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUpArrow = function SvgIconUpArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 24h24V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#959595",
    fillRule: "nonzero",
    d: "M12 6c-.258 0-.516.095-.712.283L.5 16.633 1.925 18 12 8.333 22.075 18l1.425-1.367-10.788-10.35A1.03 1.03 0 0 0 12 6"
  }))));
};
export { SvgIconUpArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMjRoMjRWMEgweiIvPgogICAgICAgIDxwYXRoIGQ9Ik0xMiA2Yy0uMjU4IDAtLjUxNi4wOTUtLjcxMi4yODNMLjUgMTYuNjMzIDEuOTI1IDE4IDEyIDguMzMzIDIyLjA3NSAxOGwxLjQyNS0xLjM2Ny0xMC43ODgtMTAuMzVBMS4wMjcgMS4wMjcgMCAwIDAgMTIgNnoiIGZpbGw9IiM5NTk1OTUiIGZpbGwtcnVsZT0ibm9uemVybyIvPgogICAgPC9nPgo8L3N2Zz4K";